// extracted by mini-css-extract-plugin
module.exports = {"specifications":"_7a3fb80146--specifications--A93Rj","specification":"_7a3fb80146--specification--eKsQt","text":"_7a3fb80146--text--EL3wJ","value":"_7a3fb80146--value--wcB9F"};